import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faToggleOn } from '@fortawesome/pro-light-svg-icons'
import { faToggleOff } from '@fortawesome/pro-light-svg-icons'

import ToggleableSectionWrapper from 'agency/digital_renderer/components/ToggleableSectionWrapper'

import LoadingBubbles from 'components/LoadingBubbles'
import styles from './styles.scss'

const renderToggle = (params) => {
  const {
    editing, enabled, toggleSection, updating,
  } = params

  if (editing && updating){
    return (
      <span className={styles.toggle}>
        <LoadingBubbles />
      </span>
    )
  }

  if (editing){
    return (
      <a className={styles.toggle} onClick={toggleSection} tabIndex="0">
        {enabled ? 'Enabled' : 'Disabled'}
        <FontAwesomeIcon icon={enabled ? faToggleOn : faToggleOff} className={styles.icon} />
      </a>
    )
  }

  return null
}

const ToggleableSection = (props) => {
  const { children, isToggleable, sectionId } = props

  return (
    <ToggleableSectionWrapper
      sectionId={sectionId}
      render={params => (
        <div className={params.enabled ? styles.root : classnames(styles.root, styles.disabled)}>
          {isToggleable && renderToggle(params)}
          {children}
        </div>
      )}
    />
  )
}

ToggleableSection.propTypes = {
  children: PropTypes.node.isRequired,
  isToggleable: PropTypes.bool,
  sectionId: PropTypes.string.isRequired,
}

ToggleableSection.defaultProps = {
  isToggleable: true,
}

export default ToggleableSection
